var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sns-main-container"},[_c('router-link',{staticClass:"timeline",attrs:{"to":{ path: '/timeline/2023' }}},[_vm._v(" timeline ")]),_vm._l((_vm.snsList),function(sns,index){return _c('div',{key:index,staticClass:"single-sns-container"},[_c('a',{staticClass:"sns-text",attrs:{"href":sns.url}},[_vm._v(_vm._s(sns.name))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }